// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';
import { canPlay, MATCH_URL_MIXCLOUD } from '../../../constants';
import { defaultProps } from '../props';
import type { BaseReactPlayerProps } from '../types';
import { callPlayer, getSDK, queryString } from '../utils';

const SDK_URL = 'https://widget.mixcloud.com/media/js/widgetApi.js';
const SDK_GLOBAL = 'Mixcloud';

export class Mixcloud extends Component<BaseReactPlayerProps> {
  static defaultProps = defaultProps;

  static canPlay = canPlay.mixcloud;

  static loopOnEnded = true;

  callPlayer = callPlayer;

  duration = null;

  currentTime = null;

  secondsLoaded = null;

  componentDidMount() {
    this.props.onMount?.(this);
  }

  load() {
    getSDK(SDK_URL, SDK_GLOBAL).then((Mixcloud) => {
      const { onReady, onPlay, onPause, error, onEnded } = this.props;

      this.player = Mixcloud.PlayerWidget(this.iframe);

      this.player.ready.then(() => {
        this.player.events.play.on(onPlay);
        this.player.events.pause.on(onPause);
        this.player.events.ended.on(onEnded);
        this.player.events.error.on(error);
        this.player.events.progress.on((seconds, duration) => {
          this.currentTime = seconds;
          this.duration = duration;
        });

        onReady();
      });
    }, this.props.onError);
  }

  play() {
    this.callPlayer('play');
  }

  pause() {
    this.callPlayer('pause');
  }

  stop() {
    // Nothing to do
  }

  seekTo(seconds) {
    this.callPlayer('seek', seconds);
  }

  setVolume() {
    // No volume support
  }

  mute = () => {
    // No volume support
  };

  unmute = () => {
    // No volume support
  };

  getDuration() {
    return this.duration;
  }

  getCurrentTime() {
    return this.currentTime;
  }

  getSecondsLoaded() {
    return null;
  }

  ref = (iframe) => {
    this.iframe = iframe;
  };

  render() {
    const { url, config } = this.props;
    const id = url.match(MATCH_URL_MIXCLOUD)[1];
    const style = {
      width: '100%',
      height: '100%'
    };
    const query = queryString({
      ...config.mixcloud.options,
      feed: `/${id}/`
    });
    // We have to give the iframe a key here to prevent a
    // weird dialog appearing when loading a new track
    return (
      <iframe
        title="Mixcloud Player"
        key={id}
        ref={this.ref}
        style={style}
        src={`https://www.mixcloud.com/widget/iframe/?${query}`}
        frameBorder="0"
        allow="autoplay"
      />
    );
  }
}
